import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { globalTheme } from "./chakraTheme/globalTheme";
import VideoPlayerPublic from "./components/courseComponents/VideoPlayerPublic";
import "./globalStyle.css";
import AdminContainer from "./middleware/AdminContainer";
import Account from "./pages/Account";
import Blog from "./pages/Blog";
import BlogCategory from "./pages/BlogCategories";
import BlogCategoryRestore from "./pages/BlogCategoriesRestore";
import BlogPost from "./pages/BlogPost";
import BlogPostEdit from "./pages/BlogPostEdit";
import BlogPostRestore from "./pages/BlogPostRestore";
import CmsLandingPage from "./pages/CmsLandingPage";
import Course from "./pages/Course";
import CourseEdit from "./pages/CourseEdit";
import CourseList from "./pages/CourseList";
import CourseRestore from "./pages/CourseRestore";
import CourseTemaPage from "./pages/CourseTema";
import CourseTemaRestore from "./pages/CourseTemaRestore";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import MissingPage from "./pages/MissingPage";
import ServerErrorPage from "./pages/ServerErrorPage";
import Signin from "./pages/Signin";

export const App = () => (
  <ChakraProvider theme={globalTheme}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Signin />} />

        <Route
          path="/home"
          element={
            <AdminContainer active={[0]} allowedRoles="">
              <Home />
            </AdminContainer>
          }
        />

        <Route
          path="/account"
          element={
            <AdminContainer active={[2]} allowedRoles="adminAccount">
              <Account />
            </AdminContainer>
          }
        />

        <Route
          path="/dashboard"
          element={
            <AdminContainer active={[1]} allowedRoles="adminAccount">
              <Dashboard />
            </AdminContainer>
          }
        />

        <Route
          path="/cms-kubuid-landingpage"
          element={
            <AdminContainer active={[3]} allowedRoles="adminCmsLandingpage">
              <CmsLandingPage />
            </AdminContainer>
          }
        />

        <Route
          path="/blog"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <Blog />
            </AdminContainer>
          }
        />

        <Route
          path="/blog/kategori"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <BlogCategory />
            </AdminContainer>
          }
        />

        <Route
          path="/blog/kategori/restore"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <BlogCategoryRestore />
            </AdminContainer>
          }
        />

        <Route
          path="/blog/post"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <BlogPost />
            </AdminContainer>
          }
        />

        <Route
          path="/blog/post/:id/edit"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <BlogPostEdit />
            </AdminContainer>
          }
        />

        <Route
          path="/blog/post/restore"
          element={
            <AdminContainer active={[4]} allowedRoles="adminBlog">
              <BlogPostRestore />
            </AdminContainer>
          }
        />

        <Route
          path="/course"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <Course />
            </AdminContainer>
          }
        />

        <Route
          path="/course/list"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CourseList />
            </AdminContainer>
          }
        />

        <Route
          path="/course/restore"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CourseRestore />
            </AdminContainer>
          }
        />

        <Route
          path="/course/:id/edit"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CourseEdit />
            </AdminContainer>
          }
        />

        <Route
          path="/course/tema"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CourseTemaPage />
            </AdminContainer>
          }
        />

        {/* <Route
          path="/course/pengguna"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CoursePengguna />
            </AdminContainer>
          }
        /> */}

        <Route
          path="/course/tema/restore"
          element={
            <AdminContainer active={[5]} allowedRoles="adminCourse">
              <CourseTemaRestore />
            </AdminContainer>
          }
        />

        <Route
          path="/tesvideo"
          element={
            <VideoPlayerPublic
              url={"https://www.youtube.com/watch?v=RoZ65BnlFu8"}
              data={{
                id: 107,
                course_id: 14,
                course_name: "Mencounter Macam Macam Jurus Jitu",
                yt_id: "ACMg78VMPSA",
                yt_url: "https://www.youtube.com/watch?v=ACMg78VMPSA",
                nama_sub_course:
                  "Cara melawan jurus jitu 'ndang ndang ndang' yang jadi jurus andalan Adam Sujagat",
                description: "sgfsdg",
                thumbnail: "/images/login.jpg",
                content_link:
                  "/course/rkiMihb6luO11PQC4WhWj60u62KShALPL9fkok06.mp4",
                level: 1,
                duration: 4,
                created_at: "2024-01-31T10:54:13.000000Z",
                updated_at: "2024-01-31T10:54:13.000000Z",
                deleted_at: "2024-01-31T10:54:13.000000Z",
              }}
            />
          }
        />

        <Route path="*" element={<MissingPage />} />
        <Route path="/servererror" element={<ServerErrorPage />} />
      </Routes>
    </BrowserRouter>
  </ChakraProvider>
);
